import type { BaseOptionType } from 'antd/lib/select';
import { getUserName } from 'models';
import { useState } from 'react';
import { DebounceSelect, type DebounceSelectProperties } from 'ui';
import { images } from 'common/utils';
// TODO: fix this import - 82948
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useUsersQuery } from 'features/users/queries/useUsersQuery';
import { AvatarOption } from './avatar-option';

type Option = { email: string; label: string; profilePhoto?: string; value: string };

type P<ValueType, OptionType extends BaseOptionType> = {
  communityId: string;
  showDetailedOption?: boolean;
} & DebounceSelectProperties<ValueType, OptionType>;

const UsersInput = ({ autoClearSearchValue = false, communityId, showDetailedOption, ...rest }: P<string, Option>) => {
  const [search, setSearch] = useState<string>();
  // TODO: create infinite scroll for users
  const { data: users, isFetching, isLoading } = useUsersQuery({ excludeCommunityId: communityId, limit: 10, search });

  const options = users?.map((user) => ({
    email: user.email,
    label: getUserName(user),
    profilePhoto: user.profilePhoto?.url,
    value: user.id,
  }));

  return (
    <DebounceSelect<string, Option>
      autoClearSearchValue={autoClearSearchValue}
      filterOption={false}
      loading={isLoading || isFetching}
      mode="multiple"
      onSearch={setSearch}
      optionRender={
        showDetailedOption
          ? (option) => (
              <AvatarOption
                email={option.data.email}
                name={option.data.label}
                photo={option.data.profilePhoto ?? images.default.userProfilePhoto}
              />
            )
          : undefined
      }
      options={options}
      showSearch
      {...rest}
    />
  );
};

export default UsersInput;
